import React from 'react';
import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

import { useUserStore } from 'stores';
import type {
  MemoryRatingAttributes,
  SingleMemoryRatingResponse,
} from 'types/Memory';

type mutationVariables = Partial<MemoryRatingAttributes>;

export function useAddMemoryRating(memoryID: string | undefined) {
  const queryClient = useQueryClient();
  const currentUserID = useUserStore(
    React.useCallback((state) => state.currentUserID, [])
  );
  const addMemoryRating = (memoryRating: mutationVariables) => {
    if (!memoryRating.memoryID || !currentUserID) {
      Promise.reject('something went wrong while rating the memory!');
    }
    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.MEMORY_RATINGS,
        attributes: { userID: currentUserID, ...memoryRating },
      },
    };

    return fetchWrapper<SingleMemoryRatingResponse>({
      url: SPARK_RESOURCE_TYPES.MEMORY_RATINGS,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addMemoryRating', addMemoryRating, {
    onSuccess: () => {
      queryClient.invalidateQueries(['ratings paginated', memoryID]);
      queryClient.invalidateQueries(['memory', memoryID]);
      toastr.success('Review Added for Memory');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Post Memory Rating: ${error.message}`);
      }
    },
  });
}
